"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListNavigationHandlers = void 0;
const react_1 = require("react");
const unselect_1 = require("../unselect");
const useListNavigationHandlers = ({ items, onActiveItemChange, activeItem, }) => {
    const index = activeItem === unselect_1.unselect ? -1 : items.indexOf(activeItem);
    const end = items.length - 1;
    return (0, react_1.useMemo)(() => ({
        onHome: () => onActiveItemChange(items[0]),
        onEnd: () => onActiveItemChange(items[end]),
        onDown: () => onActiveItemChange(items[(index + 1) % items.length]),
        onUp: () => onActiveItemChange(items[index === -1 ? end : (index - 1 + items.length) % items.length]),
    }), [onActiveItemChange, items, end, index]);
};
exports.useListNavigationHandlers = useListNavigationHandlers;
//# sourceMappingURL=useListNavigationHandlers.js.map